module.exports = __webpack_public_path__ + "static/media/bg1.a271c019.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/bg1.jpg
// module id = 887
// module chunks = 0